import { AxiosError } from 'axios';

export const ApiBase = '/api/v1';

export const generalErrorLogging = (error: AxiosError) => {
    if (error.response) {
        console.error('Request made and server responded', error.response);
    } else if (error.request) {
        console.error('The request was made but no response was received', error.request);
    } else {
        console.error(
            'Something happened in setting up the request that triggered an Error',
            error.message
        );
    }
    throw error;
};
